export const accountPlanCommand = {
  copy: 'copyAccountPlan',
};
